import {
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardMedia,
  Icon,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { settings } from "../../../customize/settings";
import { IThumbnailImageProps } from "./interfaces";

const IMAGE_URL = `${settings.apiUrl}qualitaExtImage/`;
const i18_PATH = "qualita.update.";

function Thumbnail({ image, onDelete }: IThumbnailImageProps) {
  const { t } = useTranslation();
  const imageContainer = useRef<HTMLElement>();
  const [imageWidth, setImageWidth] = useState<number>(0);

  const getSize = () => {
    const width = imageContainer?.current?.clientWidth;
    setImageWidth(width || 0);
  };
  const imageHeight = useMemo(() => imageWidth * 0.5625, [imageWidth]);

  const imageUrl = useMemo(() => `${IMAGE_URL}${image.mdPath}`, [image]);
  useEffect(() => {
    window.addEventListener("resize", getSize);
    getSize();
    return () => window.removeEventListener("resize", getSize);
  }, []);
  return (
    <Box ref={imageContainer}>
      <Card>
        <CardActionArea>
          <CardMedia
            component="img"
            height={imageHeight}
            image={imageUrl}
            sx={{ objectFit: "contain" }}
            alt="cover"
          />
        </CardActionArea>
        <CardActions>
          <Tooltip title={t(`${i18_PATH}Elimina`)}>
            <IconButton onClick={() => onDelete(image)}>
              <Icon
                className="fa-light fa-circle-trash"
                sx={{ overflow: "visible" }}
              />
            </IconButton>
          </Tooltip>
        </CardActions>
      </Card>
    </Box>
  );
}

export default Thumbnail;
